define([
    "./functioningEditionModule",
    "./functioningEditionDirective",
    "./nlgWorkingHoursEdition",
    "./nlgExceptionalWorkingHoursEdition"
], function () {
});
